import { render } from "./AgreementAndPrivacyPopup.vue?vue&type=template&id=f094a638&scoped=true"
import script from "./AgreementAndPrivacyPopup.vue?vue&type=script&lang=js"
export * from "./AgreementAndPrivacyPopup.vue?vue&type=script&lang=js"

import "./AgreementAndPrivacyPopup.vue?vue&type=style&index=0&id=f094a638&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f094a638"]])

export default __exports__